import PropTypes from 'prop-types';
import Graphic from '@arcgis/core/Graphic';
import Point from '@arcgis/core/geometry/Point';
import PictureMarkerSymbol from '@arcgis/core/symbols/PictureMarkerSymbol';
import { PoleAttribute, PoleAttributes } from '@/components/map-pole-attr';
import PoleItem from '@/utils/pole-item';

//
// 電柱描画
//
export function drawPoles(drawLayer, template, poleList) {
  if (!drawLayer) {
    return;
  }

  // 描画全消去
  drawLayer.removeAll();

  // 電柱一覧描画
  const graphics = poleList?.map((pole) => poleGraphic(pole, template));
  if (graphics) {
    drawLayer.addMany(graphics);
  }
}

// 電柱シンボル
const POLE_SYMBOL = new PictureMarkerSymbol({
  url: '/icons/pole-blue.svg',
  width: '20px',
  height: '20px',
});

/**
 * 電柱グラフィック作成
 */
export function poleGraphic(pole, template) {

  // 座標
  const point = new Point({
    latitude: pole.latitude,
    longitude: pole.longitude,
  });

  // グラフィック作成
  return new Graphic({
    symbol: POLE_SYMBOL,
    geometry: point,
    attributes: pole,
    popupTemplate: template,
  });
}

/**
 * ポップアップタイトル
 */
export function popupTitle(attr) {
  return PoleItem.longText(attr);
}

/**
 * ポップアップ内容
 */
export function PopupContent({ pole }) {
  return (
    <PoleAttributes cssStyle={{ marginTop: '8px' }}>
      <PoleAttribute label="地区"     value={pole?.areaName} />
      <PoleAttribute label="冠称"     value={pole?.lineName} />
      <PoleAttribute label="電柱番号" value={PoleItem.text(pole)} />
      <PoleAttribute label="施設名"   value={pole?.poleKind} />
    </PoleAttributes>
  );
}
PopupContent.propTypes = { pole: PropTypes.object };
